import * as React from 'react';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import i18n from 'i18next';
import { Box, Checkbox, FormControlLabel, Grid, Dialog, IconButton, Button, AppBar, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../api';
import moment from 'moment';

import HeaderYokohama from '../common/HeaderYokohama';
import FooterYokohama from '../common/FooterYokohama';
import PickupWaitTime from '../common/PickupWaitTime';

import notice_down_arrow from '../../static/yokohama/images/notice_down_arrow.png';
import notice_step2_img from '../../static/yokohama/images/notice_step2_img.png';

import TopDelivery1 from '../../static/yokohama/images/TopDelivery2_1.jpg';
import TopDelivery2 from '../../static/yokohama/images/TopDelivery2_2.png';
import TopDelivery3 from '../../static/yokohama/images/TopDelivery2_3.png';
import TopDelivery4 from '../../static/yokohama/images/TopDelivery2_4.png';
import TopDelivery5 from '../../static/yokohama/images/TopDelivery2_5.png';

@inject('commonStore', 'userStore')
@observer
class TopDelivery extends Component {
  state = {
    topPageImageUrl: '',
    dialogIsOpen: false,
  };

  async componentDidMount() {
    const { userStore } = this.props;
    await userStore.setUserDataFromLocalStorage();

    // 좌석번호 저장
    const location = window.location;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token !== null && token !== undefined && token.length > 0) {
      // 좌석정보 업데이트된 시간 계산
      const seatTokenElapsedTime = moment().diff(userStore.userData.seatTokenDateTime, 'hour');

      if (token !== this.props.userStore.userData.seatToken || seatTokenElapsedTime > 12) {
        this.props.userStore.userData.seatToken = token;
        this.props.userStore.userData.seatTokenDateTime = moment();
        this.props.userStore.saveUserData();
      }
    }

    const _consentToPrivacy = sessionStorage.getItem('consentToPrivacy');
    if (_consentToPrivacy) this.props.commonStore.consentToPrivacy = _consentToPrivacy === 'true' ? true : false;

    // CMS 에서 설정한 이미지
    const imageName = await api.getTopPageImage(this.props.userStore.userData.deliveryType);
    this.setState({
      topPageImageUrl:
        imageName.data === ''
          ? ''
          : `${window.location.protocol}//${window.location.hostname}${
              window.location.port ? ':' + window.location.port : ''
            }/CMSImage/${imageName.data}`,
      dialogIsOpen: imageName.data === '' ? false : true,
    });
  }

  handleOnChecked = e => {
    // 개인정보 제공 동의
    sessionStorage.setItem('consentToPrivacy', e.target.checked);
    this.props.commonStore.consentToPrivacy = e.target.checked;
  };

  Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  goToMain = () => {
    const { commonStore, history } = this.props;
    // 개인정보 제공에 동의 해야만 다음으로 진행 가능
    if (commonStore.consentToPrivacy) {
      history.push(`/${commonStore.companyId}/${commonStore.storeCode}`);
    } else {
      commonStore.setSnackbar(true, i18n.t('ERROR_PRIVARY_AGREEMENT'));
    }
  };
  render() {
    const { commonStore } = this.props;
    return (
      <React.Fragment>
        <AppBar position="fixed" color="header" style={{ boxShadow: 'none', zIndex: 1 }}>
          <HeaderYokohama />
        </AppBar>
        <Box className="notice-base" style={{ marginTop: '63px', backgroundColor: '#F2F2F2' }}>
          <PickupWaitTime />

          <Grid className="notice-base" style={{ padding: '20px', paddingTop: '50px' }}>
            {/** 모바일오더 안내 */}
            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div style={{ textAlign: 'center', display: 'inline-block' }}>
                <div
                  className="notice-step-font"
                  style={{
                    borderBottom: 'solid 2px #167BF1',
                    width: '120px',
                    paddingBottom: '7px',
                  }}
                >
                  About
                </div>
              </div>
              <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <img src={TopDelivery1} style={{ width: '230px' }} alt="" />
              </div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                ハマスタ座席お届けサービスは、ご注文いただいた商品をお客様のお席までお届けするデリバリーサービスです。オリジナルフードを中心に、様々な商品をお届けいたします。
              </div>
            </Grid>
          </Grid>

          <Grid
            className="notice-base fonts-noto-sans-jp"
            style={{ textAlign: 'center', paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px' }}
          >
            <div>
              <FormControlLabel
                onChange={this.handleOnChecked}
                control={<Checkbox checked={this.props.commonStore.consentToPrivacy} />}
                label={
                  <div>
                    <a href="https://www.yokohama-stadium.co.jp/delivery/term" target="_blank" rel="noreferrer">
                      サービス利用規約
                    </a>
                    <span>および</span>
                    <a href="https://www.yokohama-stadium.co.jp/privacy" target="_blank" rel="noreferrer">
                      プライバシーポリシー
                    </a>
                    に同意して
                  </div>
                }
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                onClick={this.goToMain}
                variant="contained"
                color="primary"
                style={{
                  width: '295px',
                  borderRadius: '24px',
                  height: '48px',
                  fontWeight: 'bold',
                  fontSize: '18px',
                }}
              >
                {i18n.t('BUTTON_ORDER_2')}
              </Button>
            </div>

            <div style={{ marginTop: '10px' }}>
              ※注文に進めない方は、登録状況や利用条件などを
              <a href="https://link.star-guide.baystars.co.jp/home" target="_blank" rel="noreferrer">
                BAYSTARS STAR GUIDE
              </a>
              からご確認ください。
              <br />
            </div>
          </Grid>

          <Grid className="notice-base" style={{ padding: '20px', paddingTop: '50px' }}>
            {/** 모바일오더 ACCOUNT */}
            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div style={{ textAlign: 'center', display: 'inline-block' }}>
                <div
                  className="notice-step-font"
                  style={{
                    borderBottom: 'solid 2px #167BF1',
                    width: '120px',
                    paddingBottom: '7px',
                  }}
                >
                  Account
                </div>
              </div>
              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '10px' }}>DeNAアカウントについて</div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                DeNAアカウントでログインすると、電話番号、通知用メールアドレスに、アカウントに登録されている情報が自動で入力されます
              </div>

              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '20px' }}>DeNA Pay について</div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                DeNAアカウントでログインすると、DeNA Pay でのお支払いが可能になります
              </div>

              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '20px' }}>BlueMates会員の方</div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                BlueMates会員の方は、ログインして1000円以上の金額でご注文いただくことで、STARを獲得できます。DeNAアカウントでログインしてご利用ください
                <br />※ BAYSTARS IDの手動入力連携機能はありません
              </div>

              <div style={{ fontSize: '16px', paddingTop: '15px', fontWeight: 'bold' }}>
                <a
                  href="https://support.accounts.dena.com/hc/ja/articles/34197857149721"
                  target="_blank"
                  rel="noreferrer"
                >
                  DeNAアカウントについて
                </a>
                <br />
                <a
                  href="https://support.accounts.dena.com/hc/ja/articles/31802544963609"
                  target="_blank"
                  rel="noreferrer"
                >
                  DeNA Pay について
                </a>
              </div>
            </Grid>
          </Grid>

          {/** 사용방법 */}
          <Grid
            className="notice-base"
            style={{
              textAlign: 'center',
              padding: '20px',
              paddingBottom: '40px',
              marginTop: '40px',

              background: '#f4ecdc',
              flex: 'none',
              order: 0,
              flexGrow: 0,
            }}
          >
            <div style={{ textAlign: 'center', display: 'inline-block' }}>
              <div
                className="notice-step-font"
                style={{
                  borderBottom: 'solid 2px #167BF1',
                  width: '120px',
                  paddingBottom: '7px',
                }}
              >
                How to use
              </div>
            </div>
            <div style={{ fontSize: '20px', paddingTop: '10px', paddingBottom: '40px', fontWeight: 'bold' }}>
              ハマスタ座席お届けサービスの使い方
            </div>

            <div style={{ fontSize: '16px', color: '#000', textAlign: 'left', marginBottom: '20px' }}>
              ハマスタ座席お届けサービスは、BAYSTARS STAR GUIDE
              に当日のサービス対象座席の電子チケットを登録している方のみ利用可能です。BAYSTARS STAR
              GUIDEで、詳細をご確認ください
            </div>

            <div style={{ fontSize: '16px', color: '#000', textAlign: 'center', marginBottom: '20px' }}>
              <a href="https://link.star-guide.baystars.co.jp/home" target="_blank" rel="noreferrer">
                BAYSTARS STAR GUIDEを開く
              </a>
            </div>

            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div className="notice-step-font" style={{ textAlign: 'left' }}>
                STEP 1
              </div>
              <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                BAYSTARS STAR GUIDEから
                <br />
                注文サイトへアクセス
              </div>
              <div style={{ padding: '5px' }}>
                <img src={TopDelivery2} alt="" style={{ width: '275px' }} />
              </div>

              <div style={{ fontSize: '16px', color: '#000', textAlign: 'left' }}>
                BAYSTARS STAR GUIDEを開いて、ハマスタ座席お届けサービス画面から、注文サイトへアクセスします。
                <br />
                注文サイトで商品を選択して、カートに入れます
              </div>
            </Grid>

            <div style={{ padding: '20px' }}>
              <img src={notice_down_arrow} width="44" alt="" />
            </div>

            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div className="notice-step-font" style={{ textAlign: 'left' }}>
                STEP 2
              </div>
              <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                座席情報をご確認いただき、
                <br />
                メールアドレス・電話番号を登録して、決済します
              </div>
              <div style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                <img src={TopDelivery3} width="250" alt="" />
              </div>
              <div style={{ fontSize: '16px', textAlign: 'left' }}>
                通知用メールアドレス、電話番号を入力し、決済方法を選んで購入します
                <br />
                ※座席情報は、BAYSTARS STAR GUIDEに登録している電子チケット情報が自動で反映されます。編集は不可です
              </div>
              <div style={{ fontSize: '16px', textAlign: 'left', color: 'red' }}>
                ※DeNAアカウントでログインしていただくことで、電話番号・メールアドレスは、DeNAアカウントの会員情報が自動で入力されます
              </div>
            </Grid>

            <div style={{ padding: '20px' }}>
              <img src={notice_down_arrow} width="44" alt="" />
            </div>

            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div className="notice-step-font" style={{ textAlign: 'left' }}>
                STEP 3
              </div>
              <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                完成通知を受け取ったら、座席で商品を待ちましょう！
              </div>
              <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                <img src={TopDelivery4} width="250" alt="" />
              </div>
              <div style={{ fontSize: '16px', textAlign: 'left' }}>
                完成通知メール送信後、スタッフが商品をお席にお持ちいたします。離席されている方は、確実に着席していただくようお願いします。受取番号を見せて、注文内容を確認のうえ、お受け取りください！
              </div>
            </Grid>
          </Grid>

          <Grid className="notice-base fonts-noto-sans-jp" style={{ textAlign: 'center', paddingTop: '40px' }}>
            <div style={{ padding: '20px' }}>
              <FormControlLabel
                onChange={this.handleOnChecked}
                control={<Checkbox checked={this.props.commonStore.consentToPrivacy} />}
                label={
                  <div>
                    <a href="https://www.yokohama-stadium.co.jp/delivery/term" target="_blank" rel="noreferrer">
                      サービス利用規約
                    </a>
                    <span>および</span>
                    <a href="https://www.yokohama-stadium.co.jp/privacy" target="_blank" rel="noreferrer">
                      プライバシーポリシー
                    </a>
                    に同意して
                  </div>
                }
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                onClick={this.goToMain}
                variant="contained"
                className="fonts-noto-sans-jp"
                style={{
                  width: '295px',
                  borderRadius: '24px',
                  height: '48px',
                  fontWeight: 'bold',
                  fontSize: '18px',
                }}
              >
                {i18n.t('BUTTON_ORDER_2')}
              </Button>
            </div>

            <div style={{ marginTop: '10px' }}>
              ※注文に進めない方は、登録状況や利用条件などを
              <a href="https://link.star-guide.baystars.co.jp/home" target="_blank" rel="noreferrer">
                BAYSTARS STAR GUIDE
              </a>
              からご確認ください。
              <br />
            </div>
          </Grid>

          {/** 결제종류 안내 */}
          <Grid style={{ marginTop: '64px', backgroundColor: '#FFF', padding: '40px' }}>
            <div style={{ textAlign: 'center', display: 'inline-block' }}>
              <div
                className="notice-step-font"
                style={{
                  borderBottom: 'solid 2px #167BF1',
                  width: '120px',
                  paddingBottom: '7px',
                }}
              >
                Settlement
              </div>
            </div>
            <div
              style={{
                fontSize: '20px',
                paddingTop: '10px',
                paddingBottom: '40px',
                fontWeight: 'bold',
              }}
            >
              決済方法
            </div>

            <div style={{ fontSize: '16px', color: '#000', textAlign: 'left' }}>
              本サービスは、キャッシュレスでの決済になります。以下の方法で決済が可能です。
              <br />
              ※DeNA Payでお支払いいただくには、DeNAアカウントにログインしていただく必要があります
            </div>

            <div style={{ paddingTop: '40px' }}>
              <img src={notice_step2_img} width="250" alt="" />
            </div>

            {/* <div style={{ paddingTop: '70px' }}>
              <a
                href={process.env.REACT_APP_SURVEY_URL}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'none' }}
              >
                利用者アンケート
                <br />
                ご回答にご協力ください
              </a>
            </div> */}
          </Grid>

          {/**주의사항 */}
          <Grid style={{ padding: '40px', textAlign: 'left' }}>
            <Grid style={{ paddingTop: '30px' }}>【{i18n.t('MESSAGE_NOTES')}】</Grid>
            <Grid>
              <div
                dangerouslySetInnerHTML={{
                  __html: `${commonStore.noticeText.NOTICE}`,
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            style={{
              marginTop: '40px',
              paddingLeft: '20.5px',
              paddingRight: '20.5px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img src={TopDelivery5} width="335" style={{ margin: '0px', padding: '0px' }} alt="" />
          </Grid>

          <FooterYokohama />
        </Box>

        <Dialog
          maxWidth="xl"
          fullWidth={true}
          open={this.state.dialogIsOpen}
          onClose={x => this.setState({ ...x, dialogIsOpen: false })}
        >
          <div style={{ position: 'absolute', right: '0px' }}>
            <IconButton
              aria-label="close"
              onClick={x => this.setState({ ...this.state, dialogIsOpen: !this.state.dialogIsOpen })}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <img
            src={this.state.topPageImageUrl}
            alt=""
            style={{ width: '100%', padding: '0px', margin: '0px', border: '0' }}
          />
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withRouter(TopDelivery);
